/**
 * Número corrido da TARP como o usuário o vê (`TR-0018`) — GUPM-332.
 *
 * O banco só guarda `seq`. Esta é a ÚNICA definição do formato: lista do M3, resumo
 * do Dashboard e Planos de Ação usam esta função, para que a mesma TARP nunca
 * apareça com números diferentes em telas diferentes.
 *
 * TS puro: sem React, sem Supabase, sem DOM.
 */
export function formatarNumeroTarp(seq: number): string {
  return `TR-${String(seq).padStart(4, '0')}`;
}
